/* AagamStuti footer script. Plain JavaScript, no libraries.
   On phones the link columns fold. On wider screens they stay open and the headings are plain text.
   Also runs the Back to top button. Without this script every column simply stays open. */
(function () {
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(max-width: 640px)') : { matches: false };

  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }

  function setup(root) {
    var cols = Array.prototype.slice.call(root.querySelectorAll('[data-foot-col]'));

    function paint() {
      cols.forEach(function (col) {
        var btn = col.querySelector('[data-foot-toggle]');
        var list = col.querySelector('ul');
        if (!btn || !list) return;
        if (mq.matches) {
          var open = col.getAttribute('data-open') === '1';
          btn.disabled = false;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          list.hidden = !open;
        } else {
          btn.disabled = true;
          btn.setAttribute('aria-expanded', 'true');
          list.hidden = false;
        }
      });
    }

    cols.forEach(function (col) {
      var btn = col.querySelector('[data-foot-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (!mq.matches) return;
        col.setAttribute('data-open', col.getAttribute('data-open') === '1' ? '0' : '1');
        paint();
      });
    });

    if (mq.addEventListener) mq.addEventListener('change', paint);
    else if (mq.addListener) mq.addListener(paint);

    var top = root.querySelector('[data-foot-top]');
    if (top) {
      top.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
        var logo = document.querySelector('.as-hdr__logo');
        if (logo) logo.focus({ preventScroll: true });
      });
    }
    paint();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-foot]')).forEach(function (root) {
      if (root.getAttribute('data-foot-ready')) return;
      root.setAttribute('data-foot-ready', '1');
      setup(root);
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();